import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteCoverageOption } from '../../../../../api/submissions/submission-coverages.api';
import { invalidateSubmissionCoverage } from './invalidateSubmissionCoverage';
import {
  dropFromQuoteCartVisit,
  isOpenedInQuoteCartVisit,
} from './quoteCartVisit';

/**
 * Removes an option from the cart. An option this visit created is deleted. An option the page was
 * opened from (an excess tower's Request Quote) belongs to the Coverages tab, so it only leaves the
 * cart and stays on the submission.
 */
export const useRemoveQuoteOption = (submissionId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (optionId: string) => {
      if (isOpenedInQuoteCartVisit(submissionId, optionId)) {
        dropFromQuoteCartVisit(submissionId, optionId);
        return;
      }
      await deleteCoverageOption(submissionId, optionId);
      dropFromQuoteCartVisit(submissionId, optionId);
    },
    onSuccess: () => invalidateSubmissionCoverage(queryClient, submissionId),
  });
};
